import { render } from "./SearchDropdown.vue?vue&type=template&id=d65f6608&scoped=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"

import "./SearchDropdown.vue?vue&type=style&index=0&id=d65f6608&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d65f6608"]])

export default __exports__